import {
  StyledHeader,
  WelcomeUserContainer,
  HeaderIconsContainer,
  CompanyLogoContainer,
  VerticalLine,
  HeaderLabel,
  RightHeaderSection,
  LeftHeaderSection,
  StyledImg,
  UserName,
} from './Header.Styled';
import { CompanyLogo, HeaderHome, HeaderInfo, HeaderTag, UserIcon } from '../../../assets/images/header';
import { CONSTANTS } from '../../../utils/constant';
import { fetchUserGuideVideo, selectAuthUsername } from '../../../features/auth/authSlice';
import { useSelector } from 'react-redux';
import { getCookie } from '../../../utils/helper';
import { useNavigate } from 'react-router-dom';
import UserGuideDialog from '../../../pages/Landing/components/UserGuideDialog';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../state/hooks';
import { RootState } from '../../../state/store';

const Header = () => {
  const dispatch = useAppDispatch();
  const username = useSelector(selectAuthUsername);
  const navigate = useNavigate();
  const navigateToLanding = () => {
    navigate(`/${CONSTANTS.PATH.LANDING}`);
  };
  const [openGuideDialog, setOpenGuideDialog] = useState<boolean>(false);
  const { videoURL, videoURLError, videoURLoader } = useAppSelector((state: RootState) => state.auth);

  const handleCloseGuideDialog = () => {
    setOpenGuideDialog(false);
  };

  const guideOutput = () => {
    const payload = { video_name: 'sample_video.mp4' };
    dispatch(fetchUserGuideVideo(payload));
    setOpenGuideDialog(true);
  };

  const url = videoURL.video_url;

  return (
    <StyledHeader>
      <LeftHeaderSection>
        <img src={HeaderTag} alt="Header Tag" />
        <HeaderLabel>{CONSTANTS.HEADER_LABEL}</HeaderLabel>
      </LeftHeaderSection>
      <RightHeaderSection>
        <WelcomeUserContainer>
          <UserName>{username === null ? getCookie('username') : username}</UserName>
          <StyledImg src={UserIcon} alt="User Icon" />
        </WelcomeUserContainer>
        <HeaderIconsContainer>
          <StyledImg onClick={navigateToLanding} src={HeaderHome} alt="Home Icon" />
          <StyledImg onClick={guideOutput} src={HeaderInfo} alt="Info Icon" />
        </HeaderIconsContainer>
        <VerticalLine />
        <CompanyLogoContainer>
          <StyledImg src={CompanyLogo} alt="Company Logo" />
        </CompanyLogoContainer>
      </RightHeaderSection>
      <UserGuideDialog
        open={openGuideDialog}
        onClose={handleCloseGuideDialog}
        videoUrl={url}
        loading={videoURLoader}
        error={videoURLError}
      />
    </StyledHeader>
  );
};

export default Header;
